import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import './Hero.scss';

const Hero = ({
  title,
  legend,
  subtitle,
  backgroundImage,
  cta,
  minHeight = '700px',
  overlayOpacity = 0.5,
}) => {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        minHeight: minHeight,
      }}
    >
      <div
        className="hero__overlay"
        style={{ background: `rgba(0, 0, 0, ${overlayOpacity})` }}
      ></div>
      <div className="hero__content">
        <div className="container">
          <div className="hero__inner">
            {title && (
              <h1 className="hero__title" data-aos="fade-down" data-aos-delay="100">
                {title}
              </h1>
            )}
            {legend && (
              <h2 className="hero__legend" data-aos="fade-up" data-aos-delay="200">
                {legend}
              </h2>
            )}
            {subtitle && (
              <h3 className="hero__subtitle" data-aos="fade-up" data-aos-delay="300">
                {subtitle}
              </h3>
            )}
            {cta && (
              <div className="hero__cta" data-aos="zoom-in" data-aos-delay="400">
                <Button variant="secondary" size="large" href={cta.url}>
                  {cta.text}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  backgroundImage: PropTypes.string.isRequired,
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  minHeight: PropTypes.string,
  overlayOpacity: PropTypes.number,
};

export default Hero;
